import React from "react";
import { Activity, Sparkles, BarChart3 } from "lucide-react";
import { Eyebrow, WordHeading, Reveal } from "./_shared";

const STEPS = [
  {
    n: "01",
    t: "Tell us about you",
    d: "Onboarding wizard sets your baseline — age, gear, days/week, fitness level.",
    icon: Sparkles,
  },
  {
    n: "02",
    t: "Get your AI plan",
    d: "Claude builds a weekly split + nutrition macros tuned to your body and goals.",
    icon: Activity,
  },
  {
    n: "03",
    t: "Train. Log. Progress.",
    d: "Snap meals, log sets, track measurements. Let AI handle the math.",
    icon: BarChart3,
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how" className="py-24 lg:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Eyebrow>The system</Eyebrow>
        <WordHeading
          headingClass="font-display text-5xl sm:text-6xl mb-14 max-w-2xl leading-[0.95] tracking-tight"
          tokens={[
            { w: "Three" },
            { w: "steps.", mr: "0" },
            { br: true },
            { w: "Then",  className: "text-white/50" },
            { w: "you",   className: "text-white/50" },
            { w: "train.",className: "text-white/50", mr: "0" },
          ]}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-white/10 divide-y md:divide-y-0 md:divide-x divide-white/10">
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.n} delay={idx * 120} className="p-8 md:p-10 relative">
                <div className="font-display text-7xl text-white/10 leading-none mb-4">{s.n}</div>
                <Icon className="w-5 h-5 text-[#6B9BFF] mb-3" />
                <h3 className="font-display text-2xl mb-3 leading-none">{s.t}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{s.d}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
